import React, { FC } from 'react';
import { ITrajectoryDetail } from '../../../../config/api/models/Trajectory';
import { useUser } from '../../../shared';
import {
  TrajectoryViewModeContent,
  TrajectoryViewModeContentProps,
} from './TrajectoryViewModeContent';
import {
  DifferentiationIndicatorWrapper,
  DifferentiationTitleWrapper,
  TrajectoryOwner,
  TrajectoryTitle,
} from './Atoms';

type Props = {
  trajectory: ITrajectoryDetail;
  disableEditing?: boolean;
} & TrajectoryViewModeContentProps;

export const DifferentiationIndicator: FC<Props> = ({ trajectory, disableEditing = false }) => {
  const { isTeacher } = useUser();

  return isTeacher ? (
    <DifferentiationIndicatorWrapper>
      {trajectory.parentId ? (
        <DifferentiationTitleWrapper>
          <span>
            <TrajectoryTitle>{trajectory.title}</TrajectoryTitle>
            <TrajectoryOwner>{`(${trajectory.ownerName})`}</TrajectoryOwner>
          </span>
          {!disableEditing && <TrajectoryViewModeContent trajectory={trajectory} />}
        </DifferentiationTitleWrapper>
      ) : (
        'Standaardversie'
      )}
    </DifferentiationIndicatorWrapper>
  ) : (
    <DifferentiationIndicatorWrapper>
      <TrajectoryViewModeContent trajectory={trajectory} />
    </DifferentiationIndicatorWrapper>
  );
};

/* TODO - NEEDS TRANSLATION t('differentiations.default') should be changed to 'Standaardversie' */
